import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { AccountNote } from '../../models/notes/AccountNote';
import { AccountNotesService } from '../../models/notes/AccountNotesService';
import { UIErrorHandler } from '../../core/uiErrorHandler';
import { UIHelpers } from '../../core/ui-helpers';
import { IconComponent, IconType } from '../../../../../../libs/Shared/components/icon/icon';


@Component({
  selector: 'app-account-notes',
  templateUrl: './account-notes.component.html',
  standalone: false,
})
export class AccountNotesComponent {
  @Input() merchantId: string | undefined;
  @Input() leadId: string | undefined;

  @ViewChild('notesArrow') notesArrow: IconComponent | undefined;
  @ViewChild('historyArrow') historyArrow: IconComponent | undefined;

  notesExpanded: boolean = true;
  historyExpanded: boolean = false;
  notes: AccountNote[] = [];
  newNoteText: string = '';

  // the note that is currently being edited
  activeNoteId: string | undefined;
  activeNoteText: string = '';

  rolloverId: string | undefined;

  constructor(
    private accountNoteService: AccountNotesService,
    private uiErrorHandler: UIErrorHandler,
    private cdr: ChangeDetectorRef,
  ) {}

  formatDate(date: string | undefined): string {
    if (date) {
      return UIHelpers.formatDate(date);
    } else {
      return '';
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.refreshNotes();
    this.toggleHistory(false);
  }

  refreshNotes() {
    if (this.leadId) {
      this.accountNoteService.getNotesForLead(this.leadId).then((notes) => {
        this.notes = notes;
      });
    } else if (this.merchantId) {
      this.accountNoteService
        .getNotesForMerchant(this.merchantId)
        .then((notes) => {
          this.notes = notes;
        });
    } else {
      this.uiErrorHandler.handleError(
        'No lead or merchant account was provided.',
      );
    }
  }

  btnSave_click() {
    if (this.newNoteText.trim().length == 0) {
      this.uiErrorHandler.handleError(
        'Please enter some text for your note before you save it.',
      );
      return;
    } else if (!this.merchantId) {
      this.uiErrorHandler.handleError(
        'No merchant location is selected. Please try refreshing the page.',
      );
      return;
    }

    this.accountNoteService
      .createMerchantNote(this.merchantId, this.newNoteText.trim())
      .then(() => {
        this.newNoteText = '';
        this.refreshNotes();
      });
  }

  btnSaveChanges_click() {
    if (this.activeNoteText.trim().length == 0) {
      this.uiErrorHandler.handleError(
        'Please enter some text for your note before you save it.',
      );
      return;
    } else if (!this.activeNoteId) {
      this.uiErrorHandler.handleError(
        'No note is selected. Please try refreshing the page.',
      );
      return;
    } else if (!this.merchantId) {
      this.uiErrorHandler.handleError(
        'No merchant location is selected. Please try refreshing the page.',
      );
      return;
    }

    this.accountNoteService
      .saveMerchantNote(this.activeNoteId, this.activeNoteText.trim())
      .then(() => {
        this.refreshNotes();
        this.activeNoteId = undefined;
        this.newNoteText = '';
      });
  }

  btnEdit_click(note: AccountNote) {
    this.activeNoteId = note.id;
    this.activeNoteText = note.text;
  }

  btnCancel_click() {
    this.activeNoteId = undefined;
    this.activeNoteText = '';
  }

  btnDelete_click(note: AccountNote) {
    if (confirm('Are you sure you want to delete this note?')) {
      if (!this.merchantId) {
        this.uiErrorHandler.handleError(
          'No merchant location is selected. Please try refreshing the page.',
        );
        return;
      }

      this.accountNoteService.deleteMerchantNote(note.id).then(() => {
        this.refreshNotes();
        this.activeNoteId = undefined;
      });
    }
  }

  showEditDelete(noteId: string) {
    this.rolloverId = noteId;
  }

  hideEditDelete() {
    this.rolloverId = undefined;
  }

  toggleNotes() {
    this.notesExpanded = !this.notesExpanded;

    if (this.notesArrow) {
      if (this.notesExpanded) {
        this.notesArrow.type = IconType.ArrowDown;
      } else {
        this.notesArrow.type = IconType.ArrowUp;
      }
    }
  }

  toggleHistory(show: boolean | undefined = undefined) {
    if (show == undefined) {
      this.historyExpanded = !this.historyExpanded;
    } else {
      this.historyExpanded = show;
    }

    if (this.historyArrow) {
      if (this.historyExpanded) {
        this.historyArrow.type = IconType.ArrowDown;
      } else {
        this.historyArrow.type = IconType.ArrowUp;
      }
    }

    this.cdr.detectChanges();
  }
}
